<template>
  <div class="cf-footer__links">
    <template v-for="link in group.links">
      <a
        v-if="link.link"
        :key="link.displayName"
        class="cf-link"
        :href="link.link"
        :target="link.opensNewTab ? '_blank' : '_self'"
      >
        {{ link.displayName }}
      </a>

      <p
        v-else
        :key="link.displayName"
        class="cf-link cf-link--disable-click"
      >
        {{ link.displayName }}
      </p>
    </template>
  </div>
</template>


<script>
  /** TODO:
   * Should links be rendered if none of the links are clickable? (ie. v-if="link.link")
   */
  export default {
    name: 'CustomLinks',

    props: {
      group: {
        type: Object,
        required: true
      }
    }
  };
</script>
